/**
 * Arquivo compartilhado no chat: imagem aparece em miniatura (que abre grande), com o nome embaixo;
 * outros arquivos viram uma caixa com nome, tamanho e "baixar" (chat.fileBox no original). O link
 * assinado expira, então é pedido na hora (e guardado por um tempo).
 */
import { formatBytes } from '../bytes.js';
import { useFileUrl } from '../files.js';
import { useT } from '../i18n/index.js';
import type { ChatAttachment } from '../shared.js';
import { ViewableImage } from '../ui/ImageViewer.js';

export function AttachmentView({ attachment }: { attachment: ChatAttachment }) {
  const t = useT();
  const url = useFileUrl(attachment.fileId);
  const isImage = attachment.mime.startsWith('image/');
  if (url === 'error') return <span className="rd-attach rd-attach--missing">{t('chat.file.missing', { name: attachment.name })}</span>;
  if (isImage) {
    // clicar abre a imagem grande, com "Abrir em outra aba" (BRAZ-21); embaixo, o nome do arquivo (BRAZ-26)
    return (
      <span className="rd-attach__figure">
        {url ? <ViewableImage className="rd-attach__image" src={url} name={attachment.name} /> : <span className="rd-attach__image rd-attach__image--loading" aria-label={attachment.name} />}
        <span className="rd-attach__caption" title={attachment.name}>
          {attachment.name}
        </span>
      </span>
    );
  }
  return (
    <span className="rd-attach">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M14 3H6v18h12V7zM14 3v4h4" strokeLinejoin="round" />
      </svg>
      <span className="rd-attach__meta">
        <span className="rd-attach__name">{attachment.name}</span>
        <span className="rd-attach__size">{formatBytes(attachment.size)}</span>
      </span>
      {url ? (
        <a className="rd-btn rd-btn--link" href={url} download={attachment.name} title={t('chat.file.download')}>
          {t('chat.file.download')}
        </a>
      ) : null}
    </span>
  );
}
